const uniformizeDeliveryType = (str) => {
    switch (str) {
        case 'private_driver':
            return 'Particulier';
        case 'professional_driver':
            return 'Professionnel';
        case 'livraison':
            return 'livraison';
        default:
            return str;
    }
}

export default uniformizeDeliveryType;
